import ApplicationController from '../application_controller.js';
import StimulusReflex from 'stimulus_reflex';
import throttle from 'lodash/throttle';
import consumer from '../../channels/consumer';

export default class extends ApplicationController {

  initialize() {
    let session_id = this.element.getAttribute('data-scheduled_session_id');
    console.log('[TelephonyAPI] Initializing for session:', session_id);
    StimulusReflex.register(this);

    // Check if ActionCable connection is open before calling stimulate
    if (this.isActionCableConnectionOpen()) {
      console.log('[TelephonyAPI] ActionCable already open, initializing channels');
      this.initLiveCallChannel(session_id);
      this.startIntervalRefresh();
    } else {
      console.log('[TelephonyAPI] Waiting for ActionCable connection...');
      this.waitForActionCableConnection(() => {
        console.log('[TelephonyAPI] ActionCable connected, initializing channels');
        window.stimulusReady = true;
        this.initLiveCallChannel(session_id);
        this.startIntervalRefresh();
      });
    }
  }

  waitForActionCableConnection(callback) {
    const interval = setInterval(() => {
      if (this.isActionCableConnectionOpen()) {
        clearInterval(interval);
        callback();
      }
    }, 100); // Check every 100ms
  }

  // Connect to LiveCall Rails channel to receive updates via Redis pub/sub
  initLiveCallChannel(sessionId) {
    console.log('[TelephonyAPI] Subscribing to LiveCallUpdateChannel for session:', sessionId);
    this.channel = consumer.subscriptions.create(
      { channel: "LiveCallUpdateChannel", session_id: sessionId },
      {
        connected: () => {
          console.log('[TelephonyAPI] LiveCallUpdateChannel connected');
        },
        disconnected: () => {
          console.log('[TelephonyAPI] LiveCallUpdateChannel disconnected');
        },
        received: (data) => {
          console.log('[TelephonyAPI] Received from ActionCable:', data);
          if (data.message === 'conference_changed') {
            // force: state changed outside the live-calls Redis hash (e.g. a screen
            // share in Janus), so the server must not skip the morph as "unchanged"
            const reason = data.force ? "Force" : "PubSub";
            console.log(`[TelephonyAPI] Calling LiveCall#refresh with reason ${reason}`);
            this.throttledStimulate("LiveCall#refresh", reason, { request_time: Date.now() });
          } else if (data.message === 'conference_ended') {
            console.log('[TelephonyAPI] Calling LiveCall#refresh with reason Ended');
            this.throttledStimulate("LiveCall#refresh", "Ended", { request_time: Date.now() });
          } else if (data.message === 'redirect' && data.url) {
            window.location.href = data.url;
          }
        }
      }
    );
  }

  // Fallback: refresh every 10 seconds in case pub/sub messages are missed
  // Use shorter interval (2s) in simulation mode
  startIntervalRefresh() {
    const isSimulation = this.element.getAttribute('data-simulation_mode') === 'true';
    const refreshInterval = isSimulation ? 2000 : 10000;
    console.log(`[TelephonyAPI] Starting ${refreshInterval/1000}-second interval refresh (simulation: ${isSimulation})`);
    setInterval(() => {
      console.log('[TelephonyAPI] Interval refresh triggered');
      this.throttledStimulate("LiveCall#refresh", "Interval", { request_time: Date.now() });
    }, refreshInterval);
  }

  // Throttled stimulate function
  throttledStimulate = throttle((...args) => {
    if (this.isActionCableConnectionOpen()) {
      this.stimulate(...args);
    }
  }, 500);
}
